import React, { useEffect, useState } from "react";
import { EthereumProvider } from "@walletconnect/ethereum-provider";
import { ethers } from "ethers";

// Ensure Buffer is available before using it
import { Buffer } from 'buffer';
if (!window.Buffer) {
  window.Buffer = Buffer;
}

import { contractABI, contractAddress } from "../utils/constants";  

console.log("🚀 TransactionContext is loading...");


export const TransactionContext = React.createContext();  // this is the context that we are going to use to pass the data to the components



const createEthereumContract = () => {
  // 1) Fetch the latest ethereum object from window
  const localEthereum = window.ethereum; 
  
  // 2) If no ethereum object, log and return
  if (!localEthereum) {
    console.error("No ethereum object found. Did you connect a wallet?");
    return null; // or throw new Error("No ethereum object found");
  }

  // A Provider (in ethers) is a class which provides an abstraction
  // for a connection to the Ethereum Network. It provides read-only access
  // to the blockchain and its status.
  const provider = new ethers.providers.Web3Provider(localEthereum);

  // A Signer is a class which (usually) has access to a private key,
  // which can sign messages and transactions to authorize the network 
  // to charge your account Ether to perform operations.
  const signer = provider.getSigner();

  // A Contract is an abstraction which represents a connection to a 
  // specific contract on the Ethereum Network, so that applications 
  // can use it like a normal JavaScript object.
  const transactionsContract = new ethers.Contract(
    contractAddress, 
    contractABI, 
    signer
  );

    // Return the contract so that other parts of the code can use it
    return transactionsContract;
  };

export const TransactionsProvider = ({ children }) => {   // this is the provider that we are going to wrap around our app
  const [formData, setformData] = useState({ addressTo: "", amount: "", message: "" }); // Parameters to change linked to "sendTransaction"
  const [currentAccount, setCurrentAccount] = useState("");// to connect wallet need to set this line to line 95
  const [isLoading, setIsLoading] = useState(false);
  const [transactionCount, setTransactionCount] = useState(localStorage.getItem("transactionCount"));
  const [transactions, setTransactions] = useState([]);
  const [currentCID, setCurrentCID] = useState("");  // <-- Add state for currentCID

  
  //this interact with the Inputs! exactly keybaord events (e, name) and passing to a name, will dynamically update the form data by changing and saving to e.target.value                                                                        
  const handleChange = (e, name) => {
    setformData((prevState) => ({ ...prevState, [name]: e.target.value }));
  };

  const getAllTransactions = async () => {
    try {
      const ethereum = window.ethereum;
      if (ethereum) {
        const transactionsContract = createEthereumContract();

        const availableTransactions = await transactionsContract.getAllTransactions();//function from Smart Contract

        const structuredTransactions = availableTransactions.map((transaction) => ({
          addressTo: transaction.receiver,
          addressFrom: transaction.sender,
          timestamp: new Date(transaction.timestamp.toNumber() * 1000).toLocaleString(),
          message: transaction.message,
          amount: parseInt(transaction.amount._hex) / (10 ** 18), // <-- Added comma here
          currentCID: transaction.currentCID  // Assuming currentCID is a property of the transaction object

        }));

        console.log(structuredTransactions);

        setTransactions(structuredTransactions);
      } else {
        console.log("Ethereum is not present");
      }
    } catch (error) {
      console.log(error);
    }
  };

      const checkIfWalletIsConnect = async () => {
        try {
          const ethereum = window.ethereum;
          if (!ethereum) return alert("Please connect your Crypto Wallet"); // if there is not (!) ethereum return the alert

          const accounts = await ethereum.request({ method: "eth_accounts" });

          if (accounts.length) {
            setCurrentAccount(accounts[0]);// in that way at the start of every single render we're going to have access to our Account 

            getAllTransactions();
          } else {
            console.log("No accounts found");
          }
        } catch (error) {
          console.log(error);
        }
      };

      
      let provider; // Make sure 'provider' is declared in a scope accessible by 'connectWallet'.
      
      const connectWallet = async () => {
        console.log("🔍 Initializing WalletConnect...");
      
        try {
          // 1) Check if user is on a browser with MetaMask injected:
          if (typeof window.ethereum !== "undefined" && window.ethereum.isMetaMask) {
            console.log("✅ MetaMask Detected (PC or Mobile In-App Browser)");
      
            // Use the EIP-1193 provider directly for requests (do NOT overwrite window.ethereum with an ethers provider):
            provider = window.ethereum;

            await provider.request({ method: "eth_requestAccounts" });

            // Create ethers provider for signer/network (ethers provider does NOT have .request):
            const ethersProvider = new ethers.providers.Web3Provider(provider, "any");
            const signer = ethersProvider.getSigner();
            const address = await signer.getAddress();
            const { chainId } = await ethersProvider.getNetwork();
            console.log("✅ MetaMask connected:", { address, chainId });
            setCurrentAccount(address);
      
          } else {
            // 2) Otherwise, use WalletConnect
            console.log("📡 Initializing WalletConnect...");
      
            provider = await EthereumProvider.init({
              projectId: "29369d58954e282a81a083bbb064649b", // ⚠️ Replace with your actual WC project ID
              // Required chain:
              chains: [11155111], // 11155111 = Sepolia
              // Optional chains (if the wallet supports them):
              optionalChains: [1, 17000], 
              showQrModal: true,
              rpcMap: {
                11155111: `https://sepolia.infura.io/v3/${import.meta.env.VITE_INFURA_API_KEY}`,
                1: `https://mainnet.infura.io/v3/${import.meta.env.VITE_INFURA_API_KEY}`,
                17000: `https://holesky.infura.io/v3/${import.meta.env.VITE_INFURA_API_KEY}`,
              },
              metadata: {
                name: "DeepReal",
                description: "DeepReal Wallet Connection",
                url: "https://deepreal.pmoexperts.online",
                icons: ["https://deepreal.pmoexperts.online/icon.png"],
              },
            });
      
            console.log("✅ WalletConnect Provider Initialized:", provider);
      
            // This triggers the QR code / wallet deep link:
            await provider.enable();

            // Assign the WC EIP-1193 provider to window.ethereum so normal EVM calls work:
            window.ethereum = provider;
            console.log("✅ window.ethereum is now set:", window.ethereum);

            const ethersProvider = new ethers.providers.Web3Provider(provider, "any");
            const signer = ethersProvider.getSigner();
            const address = await signer.getAddress();
            const { chainId } = await ethersProvider.getNetwork();
            console.log("✅ Wallet Connected (WC):", { address, chainId });
            setCurrentAccount(address);
          }
      
          // 3) After setting provider, fetch accounts:
          const accounts = await provider.request({ method: "eth_accounts" });
          if (accounts.length > 0) {
            console.log("✅ Wallet Connected:", accounts[0]);
          } else {
            console.log("⚠️ No accounts found.");
          }
      
          // 4) Listen for disconnections (useful if user disconnects or kills the session):
          provider.on("disconnect", () => {
            console.log("🔌 WalletConnect Disconnected");
          });
      
        } catch (error) {
          console.error("❌ Wallet Connection Error:", error);
        }
      };

  
        //most important function where all our transactions are created from the form
        const sendTransaction = async (assembledFormData) => {
          try {
            // ALWAYS grab the up-to-date window.ethereum here if needed
            const transactionsContract = createEthereumContract();
            if (!transactionsContract) {
              console.error("Cannot send transaction, no contract available.");
              return;
            }
        
            const { addressTo, amount, currentCID, message } = assembledFormData;
            const parsedAmount = ethers.utils.parseEther(amount);
        
            // 1) Request the transaction
            await window.ethereum.request({
              method: "eth_sendTransaction",
              params: [{
                from: currentAccount,
                to: addressTo,
                //gas: "0x5208", // 21000 Gwei
                value: parsedAmount._hex,
              }],
            });
        
            // 2) Call your contract function
            const transactionHash = await transactionsContract.addToBlockchain(
              addressTo,
              parsedAmount,
              message,
              currentCID
            );
            
            setIsLoading(true);
            console.log(`Loading - ${transactionHash.hash}`);
            await transactionHash.wait();
            console.log(`Success - ${transactionHash.hash}`);
            setIsLoading(false);
        
            const newCount = await transactionsContract.getTransactionCount();
            setTransactionCount(newCount.toNumber());
        
          } catch (error) {
            console.error("sendTransaction error:", error);
            throw error;
          }
        };
        
        
      

  useEffect(() => {
    checkIfWalletIsConnect();
  }, [transactionCount]);

  return (
    <TransactionContext.Provider    // this is the provider that we are going to wrap around our app  
      value={{
        transactionCount, // this is the transaction count that we are going to pass to the button
        connectWallet,  // this is the function that we are going to pass to the button
        transactions, // this is the transactions that we are going to pass to the table
        currentAccount,  // this is the current account that we are going to pass to the button
        isLoading, // this is the loading state that we are going to pass to the button
        sendTransaction, // this is the function that we are going to pass to the button
        handleChange, // this is the function that we are going to pass to the inputs
        formData, // this is the form data that we are going to pass to the inputs
        currentCID,  // <-- Expose the CID
        setCurrentCID  // <-- Expose the CID setter
      }}
    >
      {children}
    </TransactionContext.Provider>  // this is the provider that we are going to wrap around our app
  );
};
